import OrderListItem from './OrderListItem';
import { getOrderStatus, getStatusColor } from '../../../lib/utils/utils';
import { useContext, useEffect, useState } from 'react';
import TickMark from '../../../Assets/Modals/TickMark.svg';
import Minus from "../../../Assets/MinusCheckbox.svg";
import { useSelector } from 'react-redux';
import { OrdersManagementContext } from '../../../Context/OrdersManagementContext';
import { showToast } from '../../../Components/Toaster/Toaster';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/orderManagementSlice';

const getPaymentStatusColor = (status) => {
    switch (status) {
        case 'PENDING':
            return 'text-[#92400E]';
        case 'SUCCESSFUL':
            return 'text-[#208B4C]';
        case 'CANCELLED':
            return 'text-[#991B1B]';
        case 'FAILED':
            return 'text-[#666666]';
        case 'COD':
            return 'text-[#FF9900]';
        case 'REFUNDED':
            return 'text-[#1E40AF]';
        default:
            return '';
    }
}

function OrdersList() {
    const dispatch = useDispatch();

    const [ordersList, setOrdersList] = useState([]);
    const [checkboxType, setCheckboxType] = useState('');

    const { orders } = useSelector((state) => state.orderManagement.orders);
    const activeTab = useSelector((state) => state.orderManagement.activeTab);

    const { selectedOrders, setSelectedOrders } = useContext(OrdersManagementContext);

    function handleCheckboxClick() {
        if(selectedOrders.length < ordersList.length) {
            if(selectedOrders.length === 0) {
                let listId = ordersList.filter(item => item.orderStatus === 'PENDING').map(order => order.orderId);
                if(listId.length > 0) {
                    setSelectedOrders(listId);
                }
                else {
                    showToast('No orders available for call pickup.', 'warning');
                }
                return;
            }
            else {
                setSelectedOrders([]);
            }
        }
        else {
            setSelectedOrders([]);
        }
    }

    useEffect(() => {
        let tabProducts;

        switch (activeTab) {
            case 'pending':
                tabProducts = orders.filter(item => item.orderStatus === 'PENDING');
                break;
            case 'ready-to-pickup':
                tabProducts = orders.filter(item => item.orderStatus === 'READY_FOR_PICKUP');
                break;
            case 'transit':
                tabProducts = orders.filter(item => item.orderStatus === 'IN_TRANSIST');
                break;
            case 'out-for-delivery':
                tabProducts = orders.filter(item => item.orderStatus === 'OUT_FOR_DELIVERY');
                break;
            case 'delivered':
                tabProducts = orders.filter(item => item.orderStatus === 'DELIVERED');
                break;
            case 'cancelled':
                tabProducts = orders.filter(item => item.orderStatus === 'CANCELLED');
                break;
            case 'all':
            default:
                tabProducts = orders;
                break;
        }

        const sortedOrders = [ ...tabProducts ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setOrdersList(sortedOrders);
    }, [activeTab, orders]);

    useEffect(() => {
        if (selectedOrders.length === 0) {
            setCheckboxType('');
        } else if (selectedOrders.length === ordersList.filter(order => order.orderStatus === 'PENDING').length) {
            setCheckboxType('full');
        } else {
            setCheckboxType('half');
        }
    }, [selectedOrders, ordersList]);

    function multipleCallPickup() {
        dispatch(setModal('callPickup'));
    }

    return (
        <div className="flex flex-col mt-6 mx-5 select-none">
            <div className="flex bg-[#F5F5F5] font-semibold text-[#666666]">
                <div className="flex items-center gap-2 w-[22%] px-[10px] py-2 text-[14px] leading-6 uppercase">
                    {
                        ordersList.length > 0 && 
                        <div onClick={handleCheckboxClick} className={`cursor-pointer size-6 bg-[#FFFFFF] flex items-center justify-center rounded-md border ${checkboxType !== '' ? 'border-none bg-primaryColor' : 'border-[#D1D5DB]'} `} >
                            <img className='select-none' src={checkboxType === 'full' ? TickMark : checkboxType === '' ? undefined : Minus} alt="" />
                        </div>
                    }

                    <h2 className="">order id</h2>
                </div>

                <h2 className="w-[22%] px-[10px] py-2 text-[14px] leading-6 uppercase">placed on</h2>
                <h2 className="w-[10%] px-[10px] py-2 text-[14px] leading-6 uppercase">items</h2>
                <h2 className="w-[13.5%] px-[10px] py-2 text-[14px] leading-6 uppercase">total price</h2>
                <h2 className="w-[15%] px-[10px] py-2 text-[14px] leading-6 uppercase">payment method</h2>
                <h2 className="w-[13.5%] px-[10px] py-2 text-[14px] leading-6 uppercase">status</h2>
                <div className="w-[4%]"></div>
            </div>

            <div className="flex flex-col">
                {ordersList.map(item => {
                    const statusColors = getStatusColor(item.orderStatus);
                    const status = getOrderStatus(item.orderStatus);
                    const payStatus = getPaymentStatusColor(item.paymentStatus);
                    const isSelected = selectedOrders.includes(item.orderId);

                    return (
                        <OrderListItem 
                            key={item.orderId} 
                            order={item} 
                            statusColors={statusColors} 
                            orderStatus={status} 
                            payStatus={payStatus} 
                            isSelected={isSelected} 
                        />
                    );
                })}
            </div>

            {
                selectedOrders.length > 0 && 
                <div className="fixed left-1/2 -translate-x-1/2 bottom-12 border border-[#EAEAEA] bg-[#F5F5F5] rounded-xl p-4 flex items-center gap-3">
                    <button onClick={multipleCallPickup} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Call Pickup</button>
                </div>
            }
        </div>
    );
}

export default OrdersList;
